import { render, staticRenderFns } from "./CompanyFilters.vue?vue&type=template&id=60ea52c0&scoped=true&"
import script from "./CompanyFilters.vue?vue&type=script&lang=ts&"
export * from "./CompanyFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyFilters.vue?vue&type=style&index=0&id=60ea52c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea52c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ea52c0')) {
      api.createRecord('60ea52c0', component.options)
    } else {
      api.reload('60ea52c0', component.options)
    }
    module.hot.accept("./CompanyFilters.vue?vue&type=template&id=60ea52c0&scoped=true&", function () {
      api.rerender('60ea52c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyFilters.vue"
export default component.exports